export const REMOVE_FROM_CART_MUTATION = `
  mutation RemoveFromCart($visitor_id: String!, $product_id: ID!, $variant_id: String) {
    removeFromCart(visitor_id: $visitor_id, product_id: $product_id, variant_id: $variant_id) {
      success
      message
      __typename
    }
  }
`;







